import { useEnvironment } from './useEnvironment';
// Inline the brand icon markup at build time (?raw). This bundles the SVG source
// straight into the JS — no separate emitted asset and no runtime fetch — so it is
// robust in dev AND prod (the production build otherwise flattens/hashes index.html's
// referenced asset, making sibling-path derivation unreliable).
import giddyupIconSvg from '../../assets/brands/giddyup/logo-icon-admin.svg?raw';
import clubsIconSvg from '../../assets/brands/luckyquarters/logo-icon-admin.svg?raw';

// Per-brand admin favicon (#2178, follow-up). The favicon's SHAPE encodes the
// brand (giddyup horseshoe vs the Clubs mark); its COLOR still encodes the
// environment via the existing tint (useEnvironment.envFaviconTint), so a
// non-prod tab reads as e.g. "QA · luckyquarters" at a glance. Kept out of a Vue
// component because the <link rel="icon"> lives in index.html, above the app.

// Brands skinned with the Clubs mark (mirrors CompanyLogo.CLUBS_MARK_BRANDS).
const CLUBS_MARK_BRANDS = ['casinox', 'luckyquarters', 'clubs'];

// The object URL we last created, revoked on the next swap so blobs don't leak.
let lastObjectUrl = null;

function iconSvgForBrand(brandCode) {
    return CLUBS_MARK_BRANDS.includes(brandCode) ? clubsIconSvg : giddyupIconSvg;
}

// applyBrandFavicon swaps the tab icon to the given brand's mark, re-applying the
// environment tint. Safe to call with an unknown/empty code (falls back to giddyup).
export function applyBrandFavicon(brandCode) {
    const link = document.querySelector('link[rel="icon"]');
    if (!link) return;

    const { isProduction, envFaviconTint } = useEnvironment();

    let svg = iconSvgForBrand(brandCode);
    // Non-prod: recolor the tintable primary to the env tint (matches the original
    // one-shot behavior in main.js). Prod keeps the brand blue.
    if (!isProduction && envFaviconTint) {
        svg = svg.replace(/fill="#00BAFF"/g, `fill="${envFaviconTint}"`);
    }

    const blob = new Blob([svg], { type: 'image/svg+xml' });
    const objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;

    if (lastObjectUrl) URL.revokeObjectURL(lastObjectUrl);
    lastObjectUrl = objectUrl;
}
